<div class="store-finder flex-column pos-relative w-12">
    @if (!isModal) {
    <div class="flex flex-justify-between center m-b-1 w-12 p-l-1-x p-l-1-l">
        <h1 class="h3"
            translate>Our locations</h1>
    </div>
    }
    <div [ngClass]="{'flex-grow flex-column overflow-y-hidden' : !isNarrowLayout}"
         class="m-b-8-s m-b-8-m m-t-0-s m-t-0-m">
        <form class="p-l-1-x p-l-1-l p-b-1 p-b-0-s p-b-0-m"
              #form="ngForm"
              novalidate="true"
              method="post">
            <div>
                <div class="m-t">
                    <div class="w-12 pos-relative search-input">
                        <input-wrap>
                            <input class="input col-12"
                                   name="address"
                                   type="text"
                                   #addressInput
                                   [attr.placeholder]="'Town, City, Postcode' | translate"
                                   [(ngModel)]="address"
                                   (keyup)="keyup($event)"
                                   [style.font-size.rem]="1">
                            @if (status.busy) {
                            <span class="fs-1 pos-absolute top-50 right-0 flex flex-middle">
                                <i class="icon-loading pe-none m-r-10"
                                   aria-hidden="true"
                                   [style.font-size.rem]="1"></i>
                            </span>
                            }
                        </input-wrap>
                        <button class="fs-1 pos-absolute top-50 right-0 flex flex-middle"
                                (click)="search()"
                                type="button"
                                aria-label="Search">
                            <i class="icon-search p-r-2"
                               aria-hidden="true"
                               [style.font-size.rem]="1.5">
                            </i>
                        </button>
                    </div>
                </div>
                <div class="w-12 flex flex-justify-between flex-middle">
                    <p class="p2 w-6 w-12-s w-12-m p-t-5 col-12">
                        {{(currentFindableModels?.length === 1 ? '% store found' : '% stores found') | translate :
                        (currentFindableModels?.length || 0)}}</p>
                </div>
            </div>
        </form>
        <result class="p-l-1-x p-l-1-l"
                [status]="status"></result>
        @if (!isNarrowLayout) {
        <div #container
             class="w-12 overflow-y-scroll custom-scrollbar flipped">
            <div class="flipped"
                 [grid]="3"
                 [gridColumnGap]="'16px'">
                <ng-container *ngTemplateOutlet="searchResults"></ng-container>
            </div>
        </div>
        }
        @if (isNarrowLayout && currentFindableModels?.length) {
        <div class="flex flex-grow flex-column pos-relative">
            <div class="flex flex-row b-b m-b-2 m-b-5-s m-b-5-m col-12">
                <button class="p-b-2 p-l-3 p-r-3 b-w-2 b-b b-col-1 p2"
                        type="button"
                        [class.b-col-t]="isMapVisible"
                        [class.col-1]="!isMapVisible"
                        (click)="isMapVisible=false"
                        translate>List</button>
                <button class=" p-b-2 p-l-3 p-r-3 b-w-2 b-b b-col-1 p2"
                        type="button"
                        [class.b-col-t]="!isMapVisible"
                        [class.col-1]="isMapVisible"
                        (click)="isMapVisible=true"
                        translate>Map</button>
            </div>
            @switch (isMapVisible) {
            @case (true) {
            <div class="ratio-2-3"
                 #container>
                <google-map class="fill"
                            [fitBounds]="true"
                            [stores]="currentFindableModels"
                            [markerLimit]="1000"
                            (storeSelected)="onStoreMarkerClicked($event)">
                </google-map>
            </div>
            }
            @default {
            @if(isModal) {
            <ng-container *ngTemplateOutlet="searchResults"></ng-container>
            } @else {
            <div [grid]="2"
                 [gridColumnGap]="'10px'">
                <ng-container *ngTemplateOutlet="searchResults"></ng-container>
            </div>
            }
            }
            }
        </div>
        }
        @if (!currentFindableModels?.length && displaySeeRange) {
        <div>
            <p class="p2 col-12">{{ 'This product is not available in any store.' | translate }}</p>
        </div>
        }
    </div>
</div>

<!-- search results -->
<ng-template #searchResults>
    @for (store of currentFindableModels; track trackBystoreId($index, asLocalStore(store))) {
    <div class="w-12 p-b-4 flex flex-column"
         [ngClass]="!isModal ? 'center': 'b-b left' "
         [attr.id]="'store-' + store.id">
        @switch (!!this.product) {
        @case (true) {
        <div class="w-12 pos-relative flex flex-justify-between"
             [ngClass]="{ 'col-4': displaySeeRange && !getSeeRangeInStoreStatus(store.id), 'm-t-4': isModal }">
            <href class="s1"
                  [link]="asLocalStore(store).url"
                  [ga4TrackClick]="{
                        name: 'see_in_store',
                        details: {
                            device: client.isX || client.isL ? 'Desktop' : 'Mobile',
                            item_name: product?.data.name,
                            store_name: store.data.store_name,
                            item_category: product?.data.storedepartmentcode | optionLabel:'storedepartmentcode'
                        }
                    }">{{store.data.store_name}}</href>
            <button type="button"
                    (click)="showStoreDetails(asLocalStore(store))"
                    [ga4TrackClick]="{
                                name: 'see_in_store',
                                details: {
                                    device: client.isX || client.isL ? 'Desktop' : 'Mobile',
                                    item_name: product?.data.name,
                                    store_name: store.data.store_name,
                                    item_category: product?.data.storedepartmentcode | optionLabel:'storedepartmentcode'
                                }
                            }">
                <i class="icon-information"
                   aria-hidden="true"
                   [style.font-size.rem]="1.34"></i>
            </button>
        </div>
        }
        @default {
        <div class="w-12 center"
             [ngClass]="{'col-4' : displaySeeRange && !getSeeRangeInStoreStatus(store.id)}">
            <div class="pos-relative">
                <div class="w-12 ratio-1-1 m-b-2"
                     [ngClass]="{'selected' : selectedStore?.id === store.id}">
                    <img class="rf"
                         [image]="store.data?.images?.length ? store.data.images[0] : ''">
                </div>

                @if(selectedStore?.id === store.id) {
                <i class="icon-tick pos-absolute"></i>
                }
            </div>

            <href class="s1"
                  [link]="asLocalStore(store).url">{{store.data.store_name}}</href>
        </div>
        }
        }
        @if (displaySeeRange) {
        <see-range-in-store-status class="block"
                                   [store]="store"
                                   [product]="product"></see-range-in-store-status>
        }
        <p class="p1 p-t-1 col-12">{{store.data.address.replace('Barker & Stonehouse, ', '')}}</p>
        <p class="p1 p-t-1 col-12">{{store.data.city}}, {{store.data.postcode}}</p>
        @if(isModal) {
        <store-open-status class="p-t-2 p-t-1-s p-t-1-m"
                           [store]="asLocalStore(store)"></store-open-status>
        }
        @else if (store.todayOpeningHours) {
        <p class="p2 col-12 m-t-2 m-b-2">{{'Opening Hours' | translate}}@if(client.sizeId<1){<br>
                }&nbsp;{{store.todayOpeningHours?.open}} -
                {{store.todayOpeningHours?.close}}</p>
        <href [link]="asLocalStore(store).url"
              style="margin-top: auto">
            <div class="w-12 flex flex-justify-center">
                <span class="s1 m-r-3">{{ 'Store Details' | translate }}</span>
                <button type="button">
                    <i class="icon-information"
                       aria-hidden="true"
                       [style.font-size.rem]="1.5"></i>
                </button>
            </div>
        </href>
        }
    </div>
    }
</ng-template>